<template>
  <div class="register">
    <div class="content">
      <div class="info">
        <div class="info_left">
          <div class="operating">
            <p class="top-titles">{{ $t("sign_up") }}</p>
            <p v-if="registerErrorMessage" class="server-error-msg">
              <b>{{ this.errors.server }}</b>
            </p>

            <!-- <div class="input_box input_box_top">
              <span>{{ $t("firstName") }}</span>
              <el-input
                v-model="formRegister.FirstName"
                :placeholder="$t('firstName')"
              ></el-input>
            </div>
            <div class="input_box input_box_top">
              <span>{{ $t("lastName") }}</span>
              <el-input
                v-model="formRegister.LastName"
                :placeholder="$t('lastName')"
              ></el-input>
            </div> -->
            <div class="input_box input_box_top">
              <span>{{ $t("email") }}</span>
              <el-input
                :class="[this.errors.email ? 'el-input-error' : 'el-input']"
                v-model="formRegister.email"
                :placeholder="$t('enter_email_address')"
              ></el-input>
              <span class="input_error_msg">{{ this.errors.email }}</span>
            </div>
            <div class="input_box input_box_top">
              <span>{{ $t("password") }}</span>
              <el-input
                :class="[this.errors.password ? 'el-input-error' : 'el-input']"
                v-model="formRegister.password"
                type="password"
                :placeholder="$t('enter_password')"
              ></el-input>
              <span class="input_error_msg">{{ this.errors.password }}</span>
            </div>
            <div class="input_box">
              <span>{{ $t("reenter_password") }}</span>
              <el-input
                :class="[this.errors.password ? 'el-input-error' : 'el-input']"
                v-model="reenterPassword"
                type="password"
                :placeholder="$t('reenter_password')"
              ></el-input>
            </div>
            <button @click="register(formRegister)" class="create_btn">
              {{ $t("signUp") }}
            </button>
          </div>
          <div class="or-line">
            <span>{{ $t("or") }}</span>
          </div>
          <div class="login-types">
            <img
              @click="signUpWithMedia('wechat')"
              src="../assets/img/login_type_wechat.png"
              alt=""
            />
            <img
              @click="signUpWithMedia('facebook')"
              src="../assets/img/login_type_facebook.png"
              alt=""
            />
            <img
              @click="signUpWithMedia('google')"
              src="../assets/img/login_type_google.png"
              alt=""
            />
            <img
              @click="signUpWithMedia('phone')"
              src="../assets/img/login_type_phone.png"
              alt=""
            />
          </div>
          <div class="already-have" @click="goToLogin()">
            <p>
              {{ $t("already_have") }}&nbsp;<span>{{ $t("logIn") }}</span>
            </p>
          </div>
        </div>

        <div class="info_right">
          <div class="operating"></div>
        </div>
      </div>
    </div>

    <div class="login-img">
      <img src="../assets/img/signup_pic1.png" alt="" />
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  name: "register",
  data() {
    return {
      errors: {
        email: "",
        password: "",
        server: "",
      },
      labelPosition: "top",
      formRegister: {
        FirstName: "guest",
        LastName: "guest",
        email: "",
        password: "",
        username: "",
      },
      reenterPassword: "",
    };
  },
  methods: {
    ...mapActions("auth", [
      "registerRequest",
      "checkUsername",
      "checkEmail",
      "LoginRequest",
    ]),
    validEmail: function (email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    checkForm(form) {
      this.errors = [];

      if (!form.password || !this.reenterPassword) {
        this.errors.password = this.$t("passwordRequired");
      } else if (form.password !== this.reenterPassword) {
        this.errors.password = this.$t("passwordNotMatch");
      }
      // if (form.password.length < 8) {
      //   this.errors.push(this.$t("passwordLengthRequired"));
      // }
      // if (form.username.length < 5) {
      //   this.errors.push(this.$t("usernameLengthRequired"));
      // }
      if (form.email) {
        this.checkUsername({ username: form.username });
      }
      if (!form.email) {
        this.errors.email = this.$t("emailRequired");
      } else if (!this.validEmail(form.email)) {
        this.errors.email = this.$t("emailValidRequired");
      } else {
        this.checkEmail({ email: form.email });
      }
    },
    register(form) {
      form.username = this.formRegister.email;
      this.checkForm(form);
      if (!this.errors.email && !this.errors.password && !this.errors.server) {
        this.registerRequest(form)
          .then((res) => {
            this.LoginRequest({
              username: form.username,
              password: form.password,
            });
          })
          .catch((err) => {
            this.errors = [];
            this.errors.push(this.$t("errorCreateAccount"));
          });
      }
    },
    resetCreateForm() {
      this.errors = {
        email: "",
        password: "",
        server: "",
      };
      this.formRegister = {
        FirstName: "guest",
        LastName: "guest",
        email: "",
        password: "",
        username: "",
      };
      this.reenterPassword = "";
    },
    goToLogin() {
      this.$router.push("/login");
    },
    signUpWithMedia(type) {},
  },
  computed: mapState({
    registerErrorMessage: (state) => state.auth.registerErrorMessage,
  }),
  watch: {
    registerErrorMessage: function (newVal, oldVal) {
      if (newVal === "username") {
        this.errors.server = this.$t("usernameTaken");
      }
      if (newVal === "email") {
        this.errors.server = this.$t("emailTaken");
      }
      if (newVal === "fail") {
        this.errors.server = this.$t("server_error");
      }
    },
    $route(to, from) {
      this.resetCreateForm();
    },
  },
};
</script>

<style scoped lang="less">
@import "../assets/css/public.less";
@import "../assets/css/register.less";
</style>



// WEBPACK FOOTER //
// src/view/register.vue